import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiFetch } from "../lib/api"; // Your existing API helper

export default function SmartLink() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1. Fetch Link Data
  useEffect(() => {
    apiFetch(`/api/public/smart-links/${slug}`)
      .then(setData)
      .catch(() => setData(null)) // Handle 404
      .finally(() => setLoading(false));
  }, [slug]);

  // 2. Inject Facebook Pixel
  useEffect(() => {
    if (!data?.fb_pixel_id) return;

    // Standard Meta Pixel Code
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');

    // Init User's Pixel
    window.fbq('init', data.fb_pixel_id); 
    window.fbq('track', 'PageView'); // Track PageView immediately
  }, [data]);

  const handleSpotifyClick = () => {
    if (data?.fb_pixel_id) {
      // Track the conversion event!
      window.fbq('track', 'ViewContent', { 
        content_name: data.title, 
        content_category: 'Music' 
      });
    }
    window.location.href = data.spotify_url;
  };

  if (loading) return <div className="psl-shell" style={{display:'grid', placeItems:'center'}}>Loading...</div>;
  if (!data) return <div className="psl-shell">Link not found.</div>;

  return (
    <div style={{ 
      minHeight: "100vh", 
      background: "#000", 
      color: "#fff", 
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      justifyContent: "center",
      padding: 20
    }}>
      {/* Background Blur Effect */}
      <div style={{
        position: 'absolute', inset: 0, 
        backgroundImage: `url(${data.artwork_url})`, 
        backgroundSize: 'cover', opacity: 0.3, filter: 'blur(40px)', zIndex: 0
      }} />

      <div style={{ zIndex: 1, maxWidth: 400, width: '100%', textAlign: 'center' }}>
        <img 
          src={data.artwork_url} 
          alt={data.title} 
          style={{ width: '100%', borderRadius: 12, boxShadow: '0 20px 50px rgba(0,0,0,0.5)' }} 
        />
        
        <h1 style={{ marginTop: 24, fontSize: 24, fontWeight: 800 }}>{data.title}</h1>
        <p style={{ marginTop: 8, fontSize: 16, opacity: 0.8 }}>{data.artist}</p>

        <button 
          onClick={handleSpotifyClick}
          style={{
            marginTop: 32,
            width: '100%',
            background: '#1DB954', // Spotify Green
            color: '#fff',
            border: 'none',
            padding: '16px',
            borderRadius: 999,
            fontSize: 16,
            fontWeight: 700,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
            transition: 'transform 0.1s'
          }}
        >
          <img src="https://storage.googleapis.com/pr-newsroom-wp/1/2018/11/Spotify_Logo_RGB_White.png" width="24" alt="" />
          Play on Spotify
        </button>
        
        <p style={{marginTop: 20, fontSize: 11, opacity: 0.4}}>Powered by MusicBase</p>
      </div>
    </div>
  );
}